import React, { Suspense, lazy, useState, useEffect, useRef } from 'react';
import { GIVEPLS_LOGO } from './images-svg';

const PoweredBy = () => {

  return (
    <div className='powered-by'>
      <p className='small'>Powered by</p>
      <span>
        <a target="_blank" href="https://www.givepls.com/">
            {GIVEPLS_LOGO}
        </a>
      </span>
    </div>
  )
}

export default PoweredBy;